<template>
  <div class="wrapper">
    <div class="title">
      <div class="v-line"></div>
      <div class="value">友情链接<span style="font-weight: normal;font-size: 80%;margin-left:20px;">申请友情链接请联系客服</span></div>
    </div>
    <div class="h-line"></div>
    <div class="content">
      <div class="c-item" v-for="(v,i) in list" :key="i" @click="goLink(v)">
        <div class="img-box">
          <el-image :src="v.image" lazy></el-image>
        </div>
        <p class="name" :title="v.title">{{v.title}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FriendshipLink",
  data() {
    return {
      list: []
    }
  },
  created() {
    this.$request.get('/Home/friendshipLink')
        .then(res => {
          if (res.code === 0) {
            this.list = res.data
          }
        })
  },
  methods: {
    /**
     * 跳转
     * @param url
     */
    goLink({url}) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 12px;

    .v-line {
      width: 4px;
      height: 16px;
      background-color: #1464FF;
      border-radius: 9px;
    }

    .value {
      color: #2D2D2D;
      font-weight: bold;
      font-size: 18px;
      margin-left: 5px;
    }
  }

  .h-line {
    width: 100%;
    height: 1px;
    background-color: #D7D7D7;
    margin-top: 8px;
  }

  .content {
    width: 100%;
    margin-top: 25px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 25px;

    .c-item {
      cursor: pointer;
      overflow: hidden;

      &:hover {
        border-color: #1464FF;

        .el-image {
          transform: scale(1.1);
        }
      }

      .el-image {
        width: 98px;
        height: 71px;
        transition: all .3s;
      }

      .img-box {
        border: 1px solid #DCDCDC;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }

      .name {
        font-size: 14px;
        color: #666666;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin: 10px 0;
        text-align: center;
      }
    }
  }
}
</style>